import React from "react";
import PropTypes from "prop-types";
import errorReporter from "../../utils/errorReportService";

class ChartErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error for debugging
    console.error("Chart Error Boundary caught an error:", error, errorInfo);

    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    // Report error to backend
    errorReporter.report(error, errorInfo, {
      errorType: "ReactError",
      component: "ChartErrorBoundary",
    });
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI with forced debug styling
      return (
        <div
          style={{
            padding: "20px",
            border: "2px solid #ff0000",
            borderRadius: "8px",
            backgroundColor: "#1a1a1a",
            color: "#ffff00",
            textAlign: "center",
            fontFamily: "monospace",
            fontSize: "14px",
          }}
        >
          <h3
            style={{
              color: "#ff0000",
              marginTop: 0,
              fontWeight: "bold",
            }}
          >
            Chart Error
          </h3>
          <p style={{ color: "#ffff00" }}>
            Something went wrong while rendering the chart.
          </p>
          <button
            onClick={() =>
              this.setState({ hasError: false, error: null, errorInfo: null })
            }
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: "#ff0000",
              color: "#ffffff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "14px",
            }}
            data-evo-id="charterrorboundary-btn-retry"
          >
            Try Again
          </button>
          {process.env.NODE_ENV === "development" && (
            <details
              style={{
                marginTop: "15px",
                textAlign: "left",
                backgroundColor: "#000000",
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ffff00",
              }}
            >
              <summary
                style={{
                  color: "#ffff00",
                  fontWeight: "bold",
                  cursor: "pointer",
                  marginBottom: "10px",
                }}
              >
                Error Details (Development Only)
              </summary>
              <pre
                style={{
                  fontSize: "12px",
                  marginTop: "10px",
                  color: "#ffff00",
                  backgroundColor: "#1a1a1a",
                  padding: "10px",
                  borderRadius: "4px",
                  overflow: "auto",
                  whiteSpace: "pre-wrap",
                }}
              >
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

ChartErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChartErrorBoundary;
